module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/wrong_size-4e7b135e0a62be6cbd4a9d92be720aed.png";